import React from 'react';

/**
 * Club_CounterSocios (Figma) — la píldora con el recuento que acompaña al título
 * de una sección: «12 dentro», «8 carritos», «340/500 socios».
 *
 * Existía tres veces y de tres formas distintas: Socios con grises crudos de
 * Tailwind, Entradas con un icono y texto de 14, y Carritos con tokens pero
 * apagado. Ninguna era la del diseño, que es esta: píldora de 32 de alto, fondo
 * `secondary` y texto de 16 en `foreground` — el recuento es un DATO, no una
 * anotación al margen, y por eso va en el color del texto normal y no en gris.
 */
/*
 * `alert` es para cuando el propio recuento es el aviso: Preinscripciones lo usa
 * al llegar al tope de socios del plan. Va como prop y no como clase suelta
 * porque un `bg-[...]` del llamante no le gana al del componente — decide el
 * orden de la hoja, no el del atributo, y el aviso se perdería en silencio.
 */
const TONOS = {
  default: 'bg-[var(--secondary)] text-[var(--foreground)]',
  alert: 'bg-[var(--destructive-bg)] text-[var(--destructive)]',
};

export default function SectionCounter({ children, tone = 'default', className = '' }) {
  return (
    <span
      data-testid="section-counter"
      className={`inline-flex h-8 flex-shrink-0 items-center rounded-full px-3 text-base font-medium whitespace-nowrap ${TONOS[tone] || TONOS.default} ${className}`}
    >
      {children}
    </span>
  );
}
